import React, { useCallback } from "react";
import { Body2, Link, Toggle } from "@activecollab/components";
import PropTypes from "prop-types";
import { useUpdateWebhookIntegrationMutation } from "~/repository";
import { WebhookIntegrationOptions } from "./WebhookIntegrationOptions";

export const WebhookIntegrationTableRow = ({ integration }) => {
  const updateWebhookIntegrationMutation = useUpdateWebhookIntegrationMutation();

  const handleUpdate = useCallback(
    (e) => {
      const value = e.target.checked;
      updateWebhookIntegrationMutation.mutate({ id: integration.id, is_enabled: value });
    },
    [integration.id, updateWebhookIntegrationMutation]
  );

  return (
    <div className="tw-w-full tw-h-full tw-flex tw-gap-4 tw-items-center tw-p-3">
      <Body2 className="tw-flex-1 tw-max-w-[260px] tw-truncate">{integration.name}</Body2>
      <Link
        href={integration.url}
        variant="text"
        target="_blank"
        className="tw-flex-1 tw-truncate tw-no-underline tw-text-inherit"
      >
        <Body2
          className="tw-w-full tw-truncate"
          color="theme-primary"
        >
          {integration.url}
        </Body2>
      </Link>
      <div className="tw-w-[80px]">
        <Toggle
          checked={integration.is_enabled}
          onChange={handleUpdate}
        />
      </div>
      <div className="tw-w-8">
        <WebhookIntegrationOptions integration={integration} />
      </div>
    </div>
  );
};

WebhookIntegrationTableRow.propTypes = {
  integration: PropTypes.object,
};
